import styled from 'styled-components';
import {
  colorState,
  device,
  radius,
  spacing,
  typography
} from '../../Universal/Foundation';
import { primaryNavWidth } from '../../Components/globalStyles';

const profileDropdownWidth = '288';
const notificationPopupDimension = '460';

export const ExamplePopup = styled.div`
  width: 460px;
  height: 300px;
  background: white;
  box-shadow: 0px 4px 22px rgba(45, 77, 108, 0.25);
  border-radius: 16px;
  padding: 16px;
`;

export const MenuWrapper = styled.div`
  padding-left: ${primaryNavWidth - 300}px;

  ul {
    overflow: auto;
    height: 60px;
    align-items: center;

    li {
      padding: 8px 12px;
      &.active,
      &:hover {
        background-color: ${colorState.surface.brand.primary};
        transition: background-color 0.3s linear;
        border-radius: ${radius.radius_rounded}px;
      }

      @media ${device.laptopXL} {
        padding: 8px !important;

        a {
          display: flex;
        }
      }
    }
  }

  @media ${device.laptop} {
    display: none;
  }

  @media ${device.laptopL} {
    padding-left: 4px;
  }

  @media ${device.laptop} {
    padding-left: 0;

    li {
      padding: 8px 4px !important;
    }

    li a {
      display: flex;
    }
  }
`;

export const MobileMenuWrapper = styled.div`
  @media ${device.tablet} {
    width: 70% !important;
  }

  @media ${device.laptop} {
    position: absolute;
    top: 0;
    width: 30%;
    height: 100%;
    left: 0;
    z-index: 99;
    box-shadow: 0 0 10px #ccc;
    background-color: ${colorState.surface.default['topnav-bg-dark']};

    .menu-close {
      display: block;
      display: flex;
      justify-content: flex-end;
      padding: 12px;

      svg {
        path {
          stroke: white;
        }
      }
    }

    ul {
      margin: 0;
      padding: 0;
      display: flex;
      flex-direction: column;
      padding: 10px !important;
      padding-top: 0 !important;

      a {
        padding: 8px 12px;

        &.active,
        &:hover {
          background-color: ${colorState.surface.brand.primary};
          transition: background-color 0.3s linear;
          border-radius: ${radius.radius_rounded}px;
          color: white !important;
        }

        img {
          padding: 6px;
        }
      }
    }
  }
`;

export const TopNavWrapper = styled.div`
  .left {
    overflow: auto;
    scrollbar-gutter: stable overlay;
    scrollbar-width: thin;
    scrollbar-color: #d1d5db transparent;

    &::-webkit-scrollbar-thumb {
      background-color: #d1d5db;
      border-radius: 2px;
      opacity: 0;
      transition: opacity 0.2s ease;
    }

    .training-text {
      color: ${colorState.text['primary-inverse']};
      font-size: ${typography.size.tm};
      font-weight: ${typography.weight.semibold};
      line-height: 20px;
      position: relative;
      top: 2px;
      text-wrap: nowrap;
      cursor: default;

      @media screen and (min-width: 1025px) and (max-width: 1280px) {
        font-size: ${typography.size.ts};
      }
    }

    ul {
      gap: 12px !important;

      @media ${device.laptopL} {
        gap: 8px !important;

        img {
          width: auto !important;
        }
      }
    }

    @media ${device.mobileL} {
      img {
        width: 150px !important;
      }
    }
  }

  .left > div:has(> ul) {
    overflow: auto;
  }

  .right {
    z-index: 9;
    gap: 16px !important;
  }

  ul a {
    color: ${colorState.text['primary-inverse']};
    text-decoration: none;
    cursor: pointer;

    b {
      font-size: ${typography.size.ts};
      font-weight: ${typography.weight.medium};

      @media screen and (min-width: 1025px) and (max-width: 1530px) {
        font-size: ${typography.size.txs};
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
    }
  }

  .badge-icon,
  .menu-icon {
    svg,
    path {
      stroke: white;
    }
  }

  .menu-icon {
    svg,
    path {
      stroke: white;
    }

    @media ${device.laptop} {
      display: block !important;
    }
  }

  .user-login {
    display: flex;
    align-items: center;

    .user-name {
      font-size: ${typography.size.ts};
      font-weight: ${typography.weight.medium};
      color: ${colorState.text['primary-inverse']};
      padding: 12px;
      white-space: nowrap;

      @media screen and (min-width: 1025px) and (max-width: 1280px) {
        max-width: 100px !important;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      @media ${device.laptop} {
        display: none;
      }
    }
  }
`;

export const NotificationPopupContainer = styled.div`
  width: ${notificationPopupDimension}px;
  max-height: 50vh;
  overflow-y: auto;
  border-radius: 16px;
  box-shadow: 0px 4px 22px rgba(45, 77, 108, 0.25);
  display: flex;
  flex-direction: column;
  overflow: auto;

  @media ${device.mobileL} {
    position: relative;
    left: 30%;
    top: 30px;
    width: 100%;
  }

  .header,
  .body {
    background-color: white;
  }

  .header {
    padding: 12px 24px;
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;

    h3 {
      color: ${colorState.text.primary};
      font-size: ${typography.size.h6}px;
      font-weight: ${typography.weight.semibold};
      margin: 0;
    }

    span {
      color: ${colorState.text.secondary};
      font-size: ${typography.size.ts};
      font-weight: ${typography.weight.medium};
    }

    .notification-badge {
      display: flex;
      padding: 1px 6px 0px 6px;
      align-items: center;
      justify-content: center;
      border-radius: 25px;
      background-color: ${colorState.surface.default.moderate};
      color: green;
      font-size: ${typography.size.ts};
      font-weight: ${typography.weight.extrabold};
    }
  }

  .body {
    padding: 20px;
    padding-top: 6px;
  }
`;

export const ProfilePopupContainer = styled.div`
  width: ${profileDropdownWidth}px;
  max-width: 300px;
  height: auto;
  background: ${colorState.background['secondary-bg']};
  box-shadow: 0px 4px 22px rgba(45, 77, 108, 0.25);
  border: 2px solid ${colorState.border.default.white};
  border-radius: ${radius.radius_12}px;
  padding: ${spacing.spacing_8}px;
  font-weight: ${typography.weight.medium};
  font-size: ${typography.size.ts};
  color: ${colorState.text.secondary};
  cursor: default;

  .user-details {
    padding-left: 12px;

    .user-email {
      font-weight: ${typography.weight.regular};
      font-size: ${typography.size.txs};
      color: ${colorState.text.secondary};
    }
  }

  .user-name {
    font-size: ${typography.size.tm};
    font-weight: ${typography.weight.medium};
    color: ${colorState.text.primary};
  }

  .user-name,
  .user-email,
  li {
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    white-space: normal;
    word-break: break-word;
  }

  .profile-menu-options {
    max-height: 300px;
    overflow-y: auto;
    background-color: white;
    border-radius: ${radius.radius_10}px;
    padding: ${spacing.spacing_8}px;
    margin-top: 12px;

    ul {
      padding: 0;
      padding-bottom: 0;
      display: flex;
      flex-direction: column;
      overflow-y: auto;
      margin-block-start: 0;
      margin-block-end: 0;
      gap: ${spacing.spacing_8}px;

      /* li:nth-child(3) svg path {
        fill: ${colorState.icon.default.primary};
      } */

      hr {
        margin: 0;
        border: 1px solid ${colorState.border.default.tertiary};
      }

      li {
        color: ${colorState.text.secondary};
        list-style: none;
        cursor: pointer;
        padding: 10px 8px;

        p {
          font-size: ${typography.size.ts};
          font-weight: ${typography.weight.medium};
          margin-bottom: 0;
          padding-left: 12px;
          color: ${colorState.text.secondary};
        }

        :hover {
          background-color: ${colorState.surface.default.tertiary};
          border-radius: 8px;
        }

        &:focus-visible {
          border: solid 2px ${colorState.border.brand.primary};
          outline: none;
          border-radius: 8px;
        }
      }
    }
  }

  .user-login {
    .user-name {
      display: none;
    }
  }
`;

export const ReleaseNotesPopUpWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  width: 550px;
  top: 50px;
  right: 10px;
  max-width: 420px;
  max-height: 550px;
  background: ${colorState.surface.default.primary};
  box-shadow: 0px 4px 22px rgba(45, 77, 108, 0.25);
  border-radius: ${radius.radius_12}px;
  padding: ${spacing.spacing_8}px;
  font-weight: ${typography.weight.medium};
  font-size: ${typography.size.ts};
  color: ${colorState.text.primary};
  cursor: default;

  @media ${device.mobileL} {
    width: 90%;
  }

  .release-notes-header,
  .sub-header {
    color: ${colorState.text.primary};
    font-weight: ${typography.weight.medium};
    padding: ${spacing.spacing_16}px ${spacing.spacing_20}px;
    border-bottom: 1px solid ${colorState.border.default.secondary};
  }

  .release-notes-header {
    font-size: ${typography.size.h6};
    font-weight: ${typography.weight.semibold};
    line-height: ${spacing.spacing_28}px;
  }

  .sub-header {
    font-size: ${typography.size.tm};
    line-height: ${spacing.spacing_24}px;
    display: flex;
    align-items: center;
    gap: ${spacing.spacing_10}px;
    align-self: stretch;
    background: ${colorState.surface.default.secondary};
  }

  .version-release-description {
    padding-top: ${spacing.spacing_8}px;
    display: block;
    white-space: normal;
    text-overflow: ellipsis;
    max-height: 4.8em;
    overflow: hidden;
    font-weight: ${typography.weight.regular};
    color: ${colorState.text.tertiary};
    font-size: ${typography.size.ts};
    line-height: 1.4em;
  }
  .version-details {
    display: flex;
    padding: ${spacing.spacing_16}px ${spacing.spacing_20}px;
    flex-direction: column;
    align-items: flex-start;
    gap: ${spacing.spacing_8}px;
    border-bottom: 1px solid ${colorState.border.default.secondary};
  }
  .video-details {
    display: flex;
    &:hover {
      cursor: pointer;
      background-color: ${colorState.surface.brand.tertiary};
    }
  }

  .version-release-description p,
  .version-release-description ul {
    display: block !important;
    width: 100%;
    margin: 0;
    padding: 0;
  }
  .version {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
  .version-label,
  .version-value {
    font-size: ${typography.size.ts};
    font-weight: ${typography.weight.medium};
    line-height: ${spacing.spacing_20}px;
  }

  .version-label {
    color: ${colorState.text.primary};
  }

  .version-value {
    color: ${colorState.text.tertiary};
    margin-left: ${spacing.spacing_4}px;
  }

  .version-release-date {
    color: ${colorState.text.tertiary};
    font-size: ${typography.size.txs};
    font-weight: ${typography.weight.regular};
    line-height: normal;
    margin-left: ${spacing.spacing_16}px;
  }

  .version-release-description p {
    color: ${colorState.text.primary};
    font-weight: ${typography.weight.extralight};
  }
  .version-release-description ul {
    li {
      font-size: ${typography.size.ts};
      font-weight: ${typography.weight.regular};
      line-height: ${spacing.spacing_20}px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
      font-weight: ${typography.weight.regular};
      font-size: ${typography.size.ts};
    }
  }
  .read-more {
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    color: ${colorState.icon.info['primary-strong']};

    &:hover,
    &.active {
      color: ${colorState.text.info.primary};
      text-decoration: underline;
    }
  }

  .video-icon {
    display: inline-flex;
    align-items: center;
    cursor: pointer;
    padding: 6px 0;
    width: 100%;
  }
  .training-video-icon {
    width: 16px;
    height: 16px;
    filter: brightness(0);
  }
  .video-duration {
    color: ${colorState.text.tertiary};
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    white-space: nowrap;
  }
`;
